import { createFileRoute } from '@tanstack/react-router'

import { parseHistoryPage } from '@/lib/utils/history-search'

import PagePlaygroundHistory from '../pages/PagePlaygroundHistory'

type PlaygroundHistorySearch = {
  creator?: string
  page: number
  search: string
  toolType: string
  character: string
}

export const Route = createFileRoute('/playground-history')({
  component: PagePlaygroundHistory,
  validateSearch: (search: Record<string, unknown>): PlaygroundHistorySearch => {
    return {
      creator: typeof search.creator === 'string' ? search.creator : '',
      page: parseHistoryPage(search.page),
      search: typeof search.search === 'string' ? search.search : '',
      toolType: typeof search.toolType === 'string' ? search.toolType : '',
      character: typeof search.character === 'string' ? search.character : ''
    }
  }
})
